/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import BulkEmailList from './BulkEmailList';

export default function BulkEmailPage(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <BulkEmailList />
      </MainLayout>
    </div>
  );
}
